import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import { pagesRoute, publicRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ThemeSettings from "../InitialPage/themeSettings";

const isSessionActive = () => !!localStorage.getItem("dcms_token");

const ProtectedLayout = () => {
  const data = useSelector((state) => state.toggle_header);
  if (!isSessionActive()) {
    localStorage.removeItem("dcms_token");
    return <Navigate to="/signin" replace />;
  }
  return (
    <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
      <Header />
      <Sidebar />
      <Outlet />
      <ThemeSettings />
    </div>
  );
};

const Authpages = () => (
  <div>
    <Outlet />
  </div>
);

const AllRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path={"/"} element={<ProtectedLayout />}>
          {publicRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
        <Route path={"/"} element={<Authpages />}>
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </div>
  );
};

export default AllRoutes;
